import React, { useState, useEffect } from "react"
import axios from "axios"
import { useNavigate, useParams, Link } from "react-router-dom"
import Alert from 'react-bootstrap/Alert'
import { FaBars, FaEdit, FaAngleLeft } from 'react-icons/fa'
import Button from 'react-bootstrap/Button'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Form from 'react-bootstrap/Form'
import { apiURL, filesURL } from 'config/globals'
import Topbar from 'components/Topbar'
import Sidebar from 'components/Sidebar'
import Breadcrumbs from 'components/Breadcrumbs'
import Footer from 'components/Footer'
import { checkAuth } from 'utils/Auth'

const MuseumDetails = () => {
    const [currentUser, setCurrentUser] = useState(false)
    const [museum, setMuseum] = useState({})
    const [loadError, setLoadError] = useState('')
    const [buildings, setBuildings] = useState([])
    const [filteredBuildings, setFilteredBuildings] = useState([])
    const [searchValue, setSearchValue] = useState("")
    const navigate = useNavigate()
    const { id } = useParams()
    
    useEffect(() => {
        const start = async () => {
            setCurrentUser(await checkAuth(navigate))
            getMuseum(id)
        }
        start()
    }, [])

    useEffect(() => {
        searchBuilding(searchValue)
    }, [searchValue])

    const getMuseum = async (id) => {
        const response = await axios.get(`${apiURL}/get-museum/${id}`)

        if (!response.data.success) {
            setLoadError("Cannot load museum data: " + (response.data.error || response.data))
            return
        }

        setMuseum(response.data.item)
        getBuildings(response.data.item.id)
    }

    const getBuildings = async (museumId) => {
        const response = await axios.get(`${apiURL}/get-buildings/${museumId}`)

        setBuildings(response.data.rows)
        setFilteredBuildings(response.data.rows)
    }

    const searchBuilding = (str) => {
        if (!buildings || !buildings.length) {
            return
        }

        if (!str) {
            setFilteredBuildings(buildings)
            return
        }

        const lowerValue = removeAccents(str.toLowerCase())
        const filteredRows = buildings.filter(row => removeAccents(Object.values(row).join('').toLowerCase()).includes(lowerValue))
        setFilteredBuildings(filteredRows)
    }

    const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    }

    const edit = () => {
        navigate(`/museums/${museum.id}/edit`)
    }

    const back = () => {
        navigate(`/museums`)
    }

    return (
        <>
            <Topbar currentUser={currentUser} />
            <Sidebar selectedItem="museums" currentUser={currentUser} />
            <main>
                <Breadcrumbs items={[['Museums', '/museums'], [museum.name]]} />
                <div className="btn-toggle">
                    <FaBars />
                </div>
                {museum.id &&
                    <>
                        <header>
                            <div className="float-start">
                                <h1>{museum.name}</h1>
                                <small>{museum.location}</small>
                            </div>
                            <Button variant="primary" className="float-end" onClick={edit}>
                                <FaEdit /> Edit Museum
                            </Button>
                        </header>
                        <div>
                            <div className="mb-4" style={{overflow: 'hidden', height: '300px', display: 'flex', alignItems: 'center'}}>
                                <img src={`${filesURL}/${museum.mainImage}`} style={{width: '100%'}}/>
                            </div>
                            {museum.description && museum.description.split('\n\n').map((p, index) => {
                                return <p key={index}>{p}</p>
                            })}
                        </div>
                        <h3 className="mt-5 mb-4">Buildings</h3>
                        {filteredBuildings
                            ? <>
                                <Form.Control
                                    placeholder="Building quick search"
                                    onChange={e => setSearchValue(e.target.value)}
                                />
                                <div className="py-2 pl-4">
                                    <small className="float-end text-secondary">
                                        {filteredBuildings.length === buildings.length
                                            ? <>{filteredBuildings.length} buildings</>
                                            : <>{filteredBuildings.length}/{buildings.length} buildings</>
                                        }
                                    </small>
                                </div>
                                <Row>
                                    {filteredBuildings.map((building, index) =>
                                        <Col sm="6" lg="3" key={`col-${building.id}`}>
                                            <Link to={`/buildings/${building.id}`}>
                                                <Card className="mb-4">
                                                    <Card.Img
                                                        variant="top"
                                                        src={`${filesURL}/${building.mainImage}`}
                                                    />
                                                    <Card.Body>
                                                        <Card.Title>{building.name}</Card.Title>
                                                        <Card.Text>{building.description}</Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Link>
                                        </Col>
                                    )}
                                </Row>
                            </>
                            : <>No buildings found.</>
                        }
                    </>
                }
                {loadError &&
                    <>
                        <Alert key='submitError' variant='danger'>
                            {loadError}
                        </Alert>
                        <div className="mt-5 mb-4 d-grid d-lg-block">
                            <Button variant="outline-primary" size="lg" className="mb-3" onClick={back}>
                                <FaAngleLeft /> Back
                            </Button>
                        </div>
                    </>
                }
                <Footer user={currentUser} />
            </main>
        </>
    )
}

export default MuseumDetails